import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = ["value"]

import { computed, ref } from 'vue';
import type { AdminTagIndexItem } from 'src/models/tag';


export default /*@__PURE__*/_defineComponent({
  __name: 'TagMergeModal',
  props: {
    sourceTag: {},
    tags: {}
  },
  emits: ["merge", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toTagId = ref<number | null>(null);

const selectableTargetTags = computed<AdminTagIndexItem[]>(() => {
  return props.tags.filter(tag => tag.id !== props.sourceTag.id);
});
const canSubmit = computed<boolean>(() => toTagId.value !== null);

const save = (): void => {
  if (toTagId.value === null) return;

  emit('merge', { sourceId: props.sourceTag.id, targetId: toTagId.value });
};

return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: "動画タグ 名寄せ",
    "bottom-close-button-label": "OK",
    isCloseButtonDisabled: !canSubmit.value,
    onClose: save,
    onDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "form-control-label group2" }, "名寄せ元", -1)),
          _createElementVNode("select", {
            class: "form-control",
            value: __props.sourceTag.id,
            disabled: ""
          }, [
            _createElementVNode("option", {
              value: __props.sourceTag.id
            }, _toDisplayString(__props.sourceTag.tagName), 9, _hoisted_3)
          ], 8, _hoisted_2)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-control-label group2" }, "名寄せ先", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toTagId).value = $event))
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("option", { value: null }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectableTargetTags.value, (e) => {
              return (_openBlock(), _createElementBlock("option", {
                key: e.id,
                value: e.id
              }, _toDisplayString(e.tagName), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, toTagId.value]
          ])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "p2 warnings" }, " 名寄せした動画タグ情報は元に戻せないため、名寄せ元と名寄せ先に間違いが無いか十分に確認してから実行してください。 ", -1))
      ])
    ]),
    _: 1
  }, 8, ["isCloseButtonDisabled"]))
}
}

})